export const radiostations = [
  {
    id: 1,
    name: "Kids Disco",
    channel: 863,
    image: "1.jpg",
    description: "Liedjes voor de allerkleinste muziekfans",
    url: "http://kids-disco.live.xite.radio.7digital.net",
  },
  {
    id: 2,
    name: "Franse Chansons",
    channel: 864,
    image: "",
    description: "Geniet van de meest romantische klassiekers van de beste Franstalige artiesten.",
    url: "http://franse-chansons.live.xite.radio.7digital.net",
  },
  {
    id: 3,
    name: "Piratenplaten",
    channel: 865,
    image: "",
    description:
      "Haal het piratenfestijn in huis met authentieke meezingers van Jannes, Stef Ekkel en Django Wagner",
    url: "http://piratenplaten.live.xite.radio.7digital.net",
  },
  {
    id: 4,
    name: "In De Kroeg",
    channel: 866,
    image: "",
    description: "Waan je in een bruine kroeg en zing mee met de beste levensliederen",
    url: "http://in-de-kroeg.live.xite.radio.7digital.net",
  },
  {
    id: 5,
    name: "POP NL",
    channel: 867,
    image: "",
    description: "Pop van eigen bodem",
    url: "http://pop-nl.live.xite.radio.7digital.net",
  },
  {
    id: 6,
    name: "Schlagerfest",
    channel: 868,
    image: "",
    description: "Oktoberfest in je woonkamer met die schönsten Schlager",
    url: "http://schlagerfest.live.xite.radio.7digital.net",
  },
  {
    id: 7,
    name: "XITE Hits",
    channel: 869,
    image: "",
    description:
      "Check hier de meest populaire muziek van dit moment, in de mix met nieuw talent en de XITE top 20",
    url: "http://xite-hits.live.xite.radio.7digital.net",
  },
  {
    id: 8,
    name: "Muziek Van Nu",
    channel: 870,
    image: "",
    description: "Een mix van de beste Nederlandse en internationale popmuziek van dit moment",
    url: "http://muziek-van-nu.live.xite.radio.7digital.net",
  },
  {
    id: 9,
    name: "00s Heroes",
    channel: 871,
    image: "",
    description: "Alles wat ooit op je mp3-speler stond. De ultieme mixtape van de zeroes",
    url: "http://00s-heroes.live.xite.radio.7digital.net",
  },
  {
    id: 10,
    name: "Back 2 The 90s",
    channel: 872,
    image: "",
    description:
      "Van plateauzolen tot tuinbroeken, van de Spice Girls tot Nirvana. Go back 2 the 90s!",
    url: "http://back-2-the-90s.live.xite.radio.7digital.net",
  },
  {
    id: 11,
    name: "80s Flashback",
    channel: 873,
    image: "",
    description: "Ga terug naar de tijd van synthesizers, haarlak en neonkleuren",
    url: "http://80s-flashback.live.xite.radio.7digital.net",
  },
  {
    id: 12,
    name: "60s&70s Fever",
    channel: 874,
    image: "",
    description: "De grondleggers van de moderne popmuziek. Peace, Love and Happiness!",
    url: "http://60s-70s-fever.live.xite.radio.7digital.net",
  },
  {
    id: 13,
    name: "Gouwe Ouwe",
    channel: 875,
    image: "",
    description: "Wegdromen naar die goede oude tijd met nostalgische muziek vanaf de jaren 30",
    url: "http://gouwe-ouwe.live.xite.radio.7digital.net",
  },
  {
    id: 14,
    name: "Klassiek",
    channel: 876,
    image: "",
    description: "Een moment voor jezelf samen met de grootmeesters van de klassieke muziek",
    url: "http://klassiek.live.xite.radio.7digital.net",
  },
  {
    id: 15,
    name: "Yoga Flow",
    channel: 877,
    image: "",
    description: "Ontspannende muziek voor yoga, meditatie en mindfulness. Namasté",
    url: "http://yoga-flow.live.xite.radio.7digital.net",
  },
  {
    id: 16,
    name: "Op De Koffie",
    channel: 878,
    image: "",
    description: "Rustgevende popmuziek om extra te genieten van je koffiemomentje",
    url: "http://op-de-koffie.live.xite.radio.7digital.net",
  },
  {
    id: 17,
    name: "Calm Piano",
    channel: 879,
    image: "",
    description: "Instrumentale muziek voor opperste concentratie",
    url: "http://calm-piano.live.xite.radio.7digital.net",
  },
  {
    id: 18,
    name: "Mellow Beats",
    channel: 880,
    image: "",
    description: "Laat je meevoeren op deze stroom van relaxte elektronische beats",
    url: "http://mellow-beats.live.xite.radio.7digital.net",
  },
  {
    id: 19,
    name: "Take It Easy",
    channel: 881,
    image: "",
    description: "Even tot rust komen? Met deze easy-listening popmuziek kom je de dag wel door",
    url: "http://take-it-easy.live.xite.radio.7digital.net",
  },
  {
    id: 20,
    name: "Dinner Time",
    channel: 882,
    image: "",
    description: "Deze sfeervolle jazz sounds zijn hét ingrediënt om jouw diner compleet te maken",
    url: "http://dinner-time.live.xite.radio.7digital.net",
  },
  {
    id: 21,
    name: "LOVE.",
    channel: 883,
    image: "",
    description: "De ups & downs van de liefde in één playlist",
    url: "http://love.live.xite.radio.7digital.net",
  },
  {
    id: 22,
    name: "Voel Je Goed",
    channel: 884,
    image: "",
    description:
      "Jouw dagelijkse dosis positieve energie. Dit kanaal zorgt voor een glimlach op je gezicht",
    url: "http://voel-je-goed.live.xite.radio.7digital.net",
  },
  {
    id: 23,
    name: "Sing-Along",
    channel: 885,
    image: "",
    description: "One-hit wonders, guilty pleasures en andere lekkere meezingers",
    url: "http://sing-along.live.xite.radio.7digital.net",
  },
  {
    id: 24,
    name: "NL Classics",
    channel: 886,
    image: "",
    description: "Zing mee uit volle borst met de grootste Nederpop klassiekers.",
    url: "http://nl-classics.live.xite.radio.7digital.net",
  },
  {
    id: 25,
    name: "This Is EDM",
    channel: 887,
    image: "",
    description:
      "Maak van je huiskamer een club met deze selectie van elektronische dance hits en classics",
    url: "http://this-is-edm.live.xite.radio.7digital.net",
  },
  {
    id: 26,
    name: "Club Techno",
    channel: 888,
    image: "",
    description:
      "Welkom in Club Techno! Je hoeft de deur niet meer uit om bij het lekkerste feest te zijn.",
    url: "http://club-techno.live.xite.radio.7digital.net",
  },
  {
    id: 27,
    name: "Reggae Feels",
    channel: 889,
    image: "",
    description: "Haal je inner Bob Marley naar boven met deze reggae & dancehall tracks",
    url: "http://reggae-feels.live.xite.radio.7digital.net",
  },
  {
    id: 28,
    name: "Siempre Latino",
    channel: 890,
    image: "",
    description: "Gooi je heupen los op de meest exotische mix van reggaeton en latin pop",
    url: "http://siempre-latino.live.xite.radio.7digital.net",
  },
  {
    id: 29,
    name: "Country Roads",
    channel: 891,
    image: "",
    description: "Populaire countrymuziek om eindeloos van te genieten",
    url: "http://country-roads.live.xite.radio.7digital.net",
  },
  {
    id: 30,
    name: "50s&60s Rock",
    channel: 892,
    image: "",
    description: "Let’s twist again met Rock ‘n Roll uit de 50s & 60s",
    url: "http://50s-60s-rock.live.xite.radio.7digital.net",
  },
  {
    id: 31,
    name: "Classic Rock",
    channel: 893,
    image: "",
    description:
      "Al je favoriete rock-iconen verzameld in één playlist! Luister hier naar de meest legendarische rock-anthems",
    url: "http://classic-rock.live.xite.radio.7digital.net",
  },
  {
    id: 32,
    name: "Rock On",
    channel: 894,
    image: "",
    description: "Het beste wat rock te bieden heeft; dit zijn de gitaarhelden van nu",
    url: "http://rock-on.live.xite.radio.7digital.net",
  },
  {
    id: 33,
    name: "Kneiterhard",
    channel: 895,
    image: "",
    description: "Hardstyle en hardcore never die!",
    url: "http://kneiterhard.live.xite.radio.7digital.net",
  },
  {
    id: 34,
    name: "Metal Madness",
    channel: 896,
    image: "",
    description:
      "Hoe harder, hoe beter! Gooi je haren los op de meest heavy metalmuziek van vroeger en nu.",
    url: "http://metal-madness.live.xite.radio.7digital.net",
  },
  {
    id: 35,
    name: "Jazz Vibes",
    channel: 897,
    image: "",
    description:
      "Pure jazz voor de liefhebber. Lean back en geniet van deze gevarieerde jazz-selectie",
    url: "http://jazz-vibes.live.xite.radio.7digital.net",
  },
  {
    id: 36,
    name: "Soul Baby",
    channel: 898,
    image: "",
    description: "Recht vanuit het hart; de soul kings & queens van vroeger en nu",
    url: "http://soul-baby.live.xite.radio.7digital.net",
  },
  {
    id: 37,
    name: "Wereldmuziek",
    channel: 899,
    image: "",
    description:
      "Ga mee op een muzikale reis en ontdek de fijnste klanken vanuit alle hoeken van de wereld.",
    url: "http://wereldmuziek.live.xite.radio.7digital.net",
  },
  {
    id: 38,
    name: "Got The Blues",
    channel: 900,
    image: "",
    description: "Luister naar blueshelden van weleer en hoor hun opvolgers in het talent van nu.",
    url: "http://got-the-blues.live.xite.radio.7digital.net",
  },
  {
    id: 39,
    name: "Season Vibes",
    channel: 901,
    image: "",
    description:
      "De winter is voorbij, tijd om de lente te vieren. Luister dit seizoen naar de vrolijkste uptempo lentemuziek!",
    url: "http://season-vibes.live.xite.radio.7digital.net",
  },
  {
    id: 40,
    name: "Ziggo Dome",
    channel: 902,
    image: "",
    description:
      "Helaas! Voorlopig geen concerten in de Ziggo Dome. Om je toch nog dat concertgevoel te geven luister je in Best of Ziggo Dome naar een mega-mix met de grootste sterren die ooit optraden in de Amsterdamse popzaal",
    url: "http://ziggo-dome.live.xite.radio.7digital.net",
  },
];
